module.exports = __webpack_public_path__ + "img/797b646.png";